import React, { useState, useEffect } from 'react';
import Agent from "../Network/Agent";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { getStoreName } from "../Components/Utils/getStoreName";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {RouteEnumFinal} from "../Config/RouteEnum";
import {getRedirectUrl} from "../Components/Utils/getRedirectUrl";

const Splash = () => {
    const [title, setTitle] = useState('');
    const [slogan, setSlogan] = useState('');
    const [theme, setTheme] = useState({});

    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const location = useLocation()
    const tokenFromQuery = searchParams.get('token')


    useEffect(() => {

        const initializeSplash = async () => {
            const username = getStoreName();

            const handleStoreData = (store) => {
                setTitle(store.title);
                setSlogan(store.slogan);
                setTheme(store.theme);

                setTimeout(() => {
                    window.location.href = `${getRedirectUrl(store.username)}/${store.firstCategory}`;
                }, 1500);
            };

            try {
                const response = await Agent.Store.getSplash(username)
                const {store} = response.data.result

                handleStoreData(store)
            } catch (error) {
                console.log(2, error)
                if (error.response.status === 404) {
                    /*TODO : Show empty state*/
                    navigate(RouteEnumFinal.AUTH_LOGIN_PHONE)
                } else {
                    navigate(RouteEnumFinal.AUTH_LOGIN_PHONE)
                }
            }
        };

        if(tokenFromQuery) {
            Agent.setAuthToken(tokenFromQuery)
            navigate(location.pathname, {
                replace : true
            })
        } else {
            initializeSplash();
        }

    }, [tokenFromQuery]);

    return (
        <>
            <Helmet>
                <title>دیجیلوگ | {title}</title>
                <meta name="theme-color" content={theme.primaryColor} />
            </Helmet>

            <div className='splash-page-container vh-100' style={{ backgroundColor: theme.primaryColor }}>
                <div className='text-box'>
                    <div className='mobile-h1-strong title text-center' style={{ color: theme.primaryTextColor }}>
                        {title}
                    </div>
                    <div className='mobile-subtitle-regular subtitle text-center mt-12' style={{ color: theme.primaryTextColor }}>
                        {slogan}
                    </div>
                </div>
                <div className='adopted-for-splash'>
                    <Spinner
                        className={'custom-spinner d-inline-block'}
                        style={{ color: theme.primaryTextColor }}
                        animation='border' />
                </div>
            </div>
        </>
    );
};

export default Splash;
